import { createContext, useState, useEffect } from 'react'

const ResultContext = createContext()

export const ResultProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true)

  const [inventory, setInventory] = useState([])

  const [inventoryEdit, setInventoryEdit] = useState({
    item: {},
    edit: false,
  })

  useEffect(() => {
    fetchInventory()
  }, [])

  // Fetch Inventory
  const fetchInventory = async () => {
    const response = await fetch(`/inventory?_sort=id&_order=asc`)
    const data = await response.json()
    setInventory(data)
    setIsLoading(false)
  }

  const addInventory = async (newInventory) => {
    const response = await fetch('/inventory', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newInventory),
    })
    const data = await response.json()
    setInventory([...inventory, data])
  }

  // Delete an inventory card
  const deleteCard = async (id) => {
    if (window.confirm('Are you sure you want to delete?')) {
      await fetch(`/inventory/${id}`, { method: 'DELETE' })
      setInventory(inventory.filter((item) => item.id !== id))
    }
  }

  // Edit an inventory card
  const editInventory = (item) => {
    setInventoryEdit({
      item,
      edit: true,
    })
  }

  // Go to Product Page Function

  return (
    <ResultContext.Provider
      value={{
        inventory: inventory,
        isLoading,
        deleteCard: deleteCard,
        editInventory: editInventory,
      }}
    >
      {children}
    </ResultContext.Provider>
  )
}

export default ResultContext
